import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getAllMovies, deleteMovie, updateMovie } from '../api/adminApi';
import { getAssetUrl } from '../../api/client';
import '../adminTheme.css';
import './adminTables.css';

const TABS = [
  { key: '', label: 'All' },
  { key: 'now-showing', label: 'Now Showing' },
  { key: 'upcoming', label: 'Upcoming' },
];

export default function MovieListPage() {
  const { token } = useAuth();
  const [status, setStatus] = useState('');
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  async function load() {
    setLoading(true);
    setError('');
    try {
      setMovies(await getAllMovies(token, status || undefined));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  async function handleDelete(id) {
    if (!window.confirm('Delete this movie? This cannot be undone.')) return;
    try {
      await deleteMovie(token, id);
      load();
    } catch (err) {
      alert(err.message);
    }
  }

  async function handleToggleActive(movie) {
    const formData = new FormData();
    formData.append('isActive', String(!movie.isActive));
    try {
      await updateMovie(token, movie._id, formData);
      load();
    } catch (err) {
      alert(err.message);
    }
  }

  return (
    <div>
      <div className="cs-admin_page_header">
        <h1>Movies</h1>
        <Link to="/admin/movies/new" className="cs-admin_btn cs-admin_btn-primary">
          + Add Movie
        </Link>
      </div>

      <div className="cs-admin_tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={status === tab.key ? 'active' : ''}
            onClick={() => setStatus(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {error && <div className="cs-admin_error">{error}</div>}

      {loading ? (
        <p style={{ color: '#999' }}>Loading...</p>
      ) : movies.length === 0 ? (
        <p style={{ color: '#999' }}>No movies found.</p>
      ) : (
        <table className="cs-admin_table">
          <thead>
            <tr>
              <th>Poster</th>
              <th>Title</th>
              <th>Status</th>
              <th>Showtimes / Release</th>
              <th>Active</th>
              <th>Order</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {movies.map((movie) => (
              <tr key={movie._id}>
                <td>
                  <img src={getAssetUrl(movie.poster)} alt={movie.title} className="cs-admin_thumb" />
                </td>
                <td>{movie.title}</td>
                <td>
                  <span className={`cs-admin_badge cs-admin_badge-${movie.status}`}>{movie.status}</span>
                </td>
                <td>
                  {movie.status === 'now-showing'
                    ? (movie.showTimes || []).join(', ')
                    : movie.releaseDate
                    ? new Date(movie.releaseDate).toLocaleDateString()
                    : '-'}
                </td>
                <td>
                  <button className="cs-admin_toggle" onClick={() => handleToggleActive(movie)}>
                    {movie.isActive ? 'Active' : 'Hidden'}
                  </button>
                </td>
                <td>{movie.order}</td>
                <td className="cs-admin_row_actions">
                  <Link to={`/admin/movies/${movie._id}/edit`}>Edit</Link>
                  <button onClick={() => handleDelete(movie._id)} className="cs-admin_link_danger">
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
